import { useState, FunctionComponent } from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { UserRole } from "../../model";

type Props = {
    roles?: UserRole[];
    onAddRole: (role: UserRole) => void; 
}

export const AddRoleButton: FunctionComponent<Props> = ({ roles, onAddRole }) => {
    const [ show, setShow ] = useState(false);
    const [ currentRole, setCurrentRole ] = useState<UserRole>();

    const handleFormChange = (event: any) => {
        const name = event.currentTarget.name;
        let value = event.currentTarget.value;
        if (name === 'rights') {
            value = value.split(',')
                .map((el: any) => el.toString().trim())
                .filter((el: string, index: number, array: string[]) => array.indexOf(el) === index);
        }
        
        setCurrentRole({ ...currentRole, [name]: value } as UserRole)
    }

    const handleClose = () => {
        setCurrentRole(undefined);
        setShow(false)
    }

    const handleConfirm = () => {
        if (currentRole) {
            onAddRole(currentRole);
            setCurrentRole(undefined);
            setShow(false);
        }
    }

    const handleShowModal = (role: UserRole) => {
        setCurrentRole({...role});
        setShow(true);
    }

    return (
        <>
            <DropdownButton title="Add" size="sm" align="end">
                { roles && (
                    <>
                        <Dropdown.Header>
                            Predefined Roles
                        </Dropdown.Header>
                        <div style={{ maxHeight: '200px',  overflowY: 'scroll' }}>
                            {roles.map((role, index) => (
                                <Dropdown.Item
                                    key={`${role.partner}-${role.role}-${index}`}
                                    as="button"
                                    onClick={() => handleShowModal(role)}
                                >
                                    {role.role}
                                </Dropdown.Item>
                            ))}
                        </div>
                        <Dropdown.Divider />
                    </>
                )}
                <Dropdown.Header>
                    Custom Roles
                </Dropdown.Header>
                <Dropdown.Item as="button" onClick={() => handleShowModal({} as UserRole)}>
                    New Role
                </Dropdown.Item>
            </DropdownButton>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header>
                    <Modal.Title>Add Role</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group as={Row} className="mb-1">
                            <Form.Label column xs="2">
                                <strong>Role</strong>
                            </Form.Label>
                            <Col xs="10">
                                <Form.Control 
                                    id="role"
                                    name="role"
                                    defaultValue={currentRole?.role}
                                    onChange={handleFormChange}
                                />
                                <Form.Text id="partner" muted={true}>
                                    Prefixing the role name with an ISO Country code will automagically make it a regional role
                                </Form.Text>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-1">
                            <Form.Label column xs="2">
                                <strong>Partner</strong>
                            </Form.Label>
                            <Col xs="10">
                                <Form.Control 
                                    id="partner"
                                    name="partner"
                                    defaultValue={currentRole?.partner} 
                                    onChange={handleFormChange}
                                />
                                <Form.Text id="partner" muted={true}>
                                    Must be either "sky" or "comcast"
                                </Form.Text>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-1">
                            <Form.Label column xs="2">
                                <strong>Rights</strong>
                            </Form.Label>
                            <Col xs="10">
                                <Form.Control 
                                    id="rights"
                                    name="rights"
                                    as="textarea"
                                    style={{ height: '150px' }}
                                    defaultValue={currentRole?.rights} 
                                    onChange={handleFormChange}
                                />
                                <Form.Text id="rights" muted={true}>
                                    Rights must be entered in a comma separated format (no spaces)
                                </Form.Text>
                            </Col>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" onClick={handleClose} size="sm">
                        Cancel
                    </Button>
                    <Button variant="outline-primary" onClick={handleConfirm} size="sm">
                        Ok
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}